import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=5585bdc4&lang=css"
import "./App.vue?vue&type=style&index=1&id=5585bdc4&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=2&id=5585bdc4&lang=css"
import "./App.vue?vue&type=style&index=3&id=5585bdc4&lang=css"
import "./App.vue?vue&type=style&index=4&id=5585bdc4&lang=css"
import "./App.vue?vue&type=style&index=5&id=5585bdc4&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5585bdc4"]])

export default __exports__